import { render, staticRenderFns } from "./HoteltList.vue?vue&type=template&id=ad1f480a&scoped=true&"
import script from "./HoteltList.vue?vue&type=script&lang=ts&"
export * from "./HoteltList.vue?vue&type=script&lang=ts&"
import style0 from "./HoteltList.vue?vue&type=style&index=0&id=ad1f480a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1f480a",
  null
  
)

export default component.exports